import gql from 'graphql-tag';
const A_LETTERS_KPM_ACTIVITY_FRAGMENT = gql `
  fragment ALettersKpmActivityFragment on ALettersKpmActivity {
    targetKey
    rounds {
      keystrokes
      numberOfKeystrokes
    }
  }
`;
export default A_LETTERS_KPM_ACTIVITY_FRAGMENT;
